// extracted by mini-css-extract-plugin
export var label = "_cx-1";
export var reminder = "_cx-0";